var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TaoDonVi',{key:this.$route.query.id + this.$route.query.onlyview})}
var staticRenderFns = []

export { render, staticRenderFns }